import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Location } from '@angular/common';

import { BpgCommonService } from '../app/bpg-common/services/bpg-common.service';
import { EnvironmentConfiguration } from './environment/services/environment.configuration';
import { DataService } from './bpg-common/services/data.services';
declare const $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  path = ''
  isActive = false;
  backgroundActive = false;
  transitionBannerData: any = {
    message: 'Notice: BPG Connect is transitioning to ERG Connect as part of Evolving Together: BPG To ERG. You may see some changes during this process. Please pardon the "dust"—completion is expected by June 1st. Thanks for your patience!',
    type: 'warning',
    dismissalKey: 'transition-banner-dismissed'
  };
  constructor(
    private readonly router: Router,
    private readonly location: Location,
    private readonly data: DataService,
    private readonly bpgCommonService: BpgCommonService,
    private readonly environment1: EnvironmentConfiguration) {

    router.events.subscribe(async event => {

      if (event instanceof NavigationStart) {
        const queryParams = new URLSearchParams(window.location.search);
        const codeResponse = queryParams.get('code');
        const authError = queryParams.get('error');
        if (codeResponse && !authError) {
          const codeVerifier = sessionStorage.getItem('code_verifier');
          sessionStorage.clear();
          if (codeVerifier) {
            sessionStorage.setItem('code_verifier', codeVerifier);
          }
          sessionStorage.setItem('codeResponse', codeResponse)
        }
      }

    })

    this.router.events.subscribe((_val) => {
      this.path = this.location.path();
    });


  }
  title = 'bpg-webapp';
  menuDisplay: any;
  expiryMsg = `Your session will expire in 5 minutes. Kindly save all your changes`;
  expiryTime: number;
  expiryWarnTime: number;
  interval: any;
  timeInterval: any;

  ngOnInit() {
    // Redirect bpg hostnames to erg hostnames for QA/PROD before app bootstraps auth-sensitive flows.
    const hostname = window.location.hostname;
    const redirectHost =
      this.environment1.envName === 'qa' && hostname === 'qa.bpg.toyota.com'
        ? 'qa.erg.toyota.com'
        : this.environment1.envName === 'prod' && hostname === 'bpg.toyota.com'
          ? 'erg.toyota.com'
          : null;
    if (redirectHost && !window.location.search.includes('code=')) {
      const url = new URL(window.location.href);
      url.hostname = redirectHost;
      window.location.href = url.toString();
      return;
    }

    window.setTimeout(() => {
      $('#tokenExpiry').modal('show');
    }, (600000 * 5));
    if (sessionStorage.getItem('id_token') != null && sessionStorage.getItem('XAapiKey') != null)    {
      this.isActive = true;
    }

    if(this.isActive === false)
    {
      this.bpgCommonService.isTokenPresent.subscribe(tokenRes => {
     if (tokenRes) {
          this.isActive = tokenRes
        }
      })
    }
  


    window.setTimeout(() => {
      this.refreshToken();
    }, (600000 * 5));
    if (this.environment1.envName === 'default' || this.environment1.envName === 'local' || this.environment1.envName === 'staging') {
      localStorage.setItem('userManagementUrl', this.environment1.apiBaseUrl + '7000');
      localStorage.setItem('eventManagementUrl', this.environment1.apiBaseUrl + '7001');
      localStorage.setItem('financialManagementUrl', this.environment1.apiBaseUrl + '7002');
    } else if (this.environment1.envName === 'qa' || this.environment1.envName === 'prod') {
      localStorage.setItem('userManagementUrl', this.environment1.apiBaseUrl);
      localStorage.setItem('eventManagementUrl', this.environment1.eventapiBaseUrl);
      localStorage.setItem('financialManagementUrl', this.environment1.financeapiBaseUrl);
    }
    else {
      localStorage.setItem('userManagementUrl', this.environment1.apiBaseUrl);
      localStorage.setItem('eventManagementUrl', this.environment1.apiBaseUrl);
      localStorage.setItem('financialManagementUrl', this.environment1.apiBaseUrl);
    }

    this.data.siteEffectedPopup.subscribe(data=>{
      if(data==='true'){
         this.backgroundActive = true;
      }else{
        this.backgroundActive = false;
      }
     });

  }
  async refreshToken() {
    this.bpgCommonService.refreshToken()

  }
  clearTime() {
    $('#tokenExpiry').modal('hide');
    window.location.reload();
  }
}

